import { render, staticRenderFns } from "./ErrorPage.html?vue&type=template&id=9e9707c0&external"
import script from "./ErrorPage.js?vue&type=script&lang=js&external"
export * from "./ErrorPage.js?vue&type=script&lang=js&external"
import style0 from "./ErrorPage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports